import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CanvasBoard from './pages/CanvasBoard';
import PrivateRoute from './comp/PrivateRoute';
import BoardList from './pages/CreateBoard';
import './App.css'

function App() {
  const [data, setData] = useState();
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'system');
  useEffect(() => {
    const root = window.document.documentElement;

    const applyTheme = () => {
      const isDark = 
        theme === 'dark' || 
        (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
      
      root.classList.toggle('dark', isDark);
    };

    applyTheme();
    localStorage.setItem('theme', theme);

  }, [theme]);
  useEffect(() => {
    fetch(process.env.REACT_APP_APP_URL + '/protected', {
      method: 'GET',
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => {
        if (data.message === 'Unauthorized' || data.message === 'Invalid token') {
          setData(data);
        } else {
          setData(data);
        }
      });
  }, []);
  
  if (!data) {
    return <>
<style>{`
  .bounce-custom {
    animation: bounce-customk 1s infinite ease-in-out;
  }

  .shadow-pulse {
    animation: shadow-pulsek 1s infinite ease-in-out;
  }

  .wave-stroke {
    stroke-dasharray: 400;
    stroke-dashoffset: 400;
    animation: draw-wave 2s ease-in-out infinite;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .wave-1 {
    stroke: #06b6d4;
    animation-delay: 0s;
  }

  .wave-2 {
    stroke: #d946ef;
    animation-delay: 0.15s;
  }

  .wave-3 {
    stroke: #fbbf24;
    animation-delay: 0.3s;
  }

  @keyframes draw-wave {
    0% {
      stroke-dashoffset: 400;
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    80% {
      stroke-dashoffset: 0;
      opacity: 1;
    }
    100% {
      stroke-dashoffset: 0;
      opacity: 0;
    }
  }

  @keyframes bounce-customk {
    0%, 100% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
    50% {
      transform: translateY(-20px);
      animation-timing-function: ease-in;
    }
  }

  @keyframes shadow-pulsek {
    0%, 100% {
      transform: scale(1);
      opacity: 0.4;
    }
    50% {
      transform: scale(0.5);
      opacity: 0.2;
    }
  }

  .font-marker {
    font-family: 'Permanent Marker', cursive;
  }
  .font-body { font-family: 'Outfit', sans-serif; }
`}</style>

<div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#f8f9fa] dark:bg-gray-900">
 
  <div className="flex items-center gap-2 group">
     <div className="flex flex-col items-center justify-center min-h-[100px] ">
      <span className='bg-slate-800 dark:bg-gray-700 text-white p-1.5 rounded-lg group-hover:rotate-12 transition-transform bounce-custom'>
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
      </span>      
      <div className="w-10 h-1 bg-black dark:bg-gray-300 rounded-[50%] shadow-pulse blur-[1px]"></div>
    </div>
    <span className="font-body font-bold text-xl tracking-tight text-gray-700 dark:text-white">doodle<span className='text-yellow-400 ml-0.5'>up</span></span>
  </div>
  <p className="text-slate-400 dark:text-gray-500 font-sans text-xs font-bold uppercase tracking-widest mt-4">
    Please wait 5-10 Seconds
  </p>
</div>
    </>
  }
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home data={data} setData={setData} />} />
        <Route path="/b" element={<PrivateRoute data={data}><BoardList data={data} /></PrivateRoute>} />
        <Route path="/b/:id" element={<PrivateRoute data={data}><CanvasBoard data={data} setData={setData} /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;